import * as React from "react";

function Exclamation() {
  return (
    <svg
      width="17.297"
      height="16"
      viewBox="0 0 31 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M29.1719 22.3047L17.5234 2.39844C16.5938 0.867188 14.3516 0.867188 13.4766 2.39844L1.77344 22.3047C0.898438 23.8359 1.99219 25.75 3.79688 25.75H27.1484C28.9531 25.75 30.0469 23.8359 29.1719 22.3047ZM14.1875 8.6875C14.1875 7.97656 14.7344 7.375 15.5 7.375C16.2109 7.375 16.8125 7.97656 16.8125 8.6875V15.6875C16.8125 16.4531 16.2109 17 15.5 17C14.8438 17 14.1875 16.4531 14.1875 15.6875V8.6875ZM15.5 22.25C14.5156 22.25 13.75 21.4844 13.75 20.5547C13.75 19.625 14.5156 18.8594 15.5 18.8594C16.4297 18.8594 17.1953 19.625 17.1953 20.5547C17.1953 21.4844 16.4297 22.25 15.5 22.25Z"
        fill="#D91014"
      />
    </svg>
  );
}

export default Exclamation;
